import React from 'react'

function rateColor(rate) {
  if (rate >= 0.7) return '#3a8a5a'
  if (rate >= 0.4) return '#e89a5d'
  return '#e85d5d'
}

export function PrepRateBar({ team, prepRate, memberCount }) {
  const pct = Math.round(prepRate * 100)
  return (
    <div style={styles.row}>
      <div style={styles.team}>{team}</div>
      <div style={styles.barWrap}>
        <div
          style={{
            ...styles.bar,
            width: `${pct}%`,
            background: rateColor(prepRate),
          }}
        />
      </div>
      <div style={styles.pct}>{pct}%</div>
    </div>
  )
}

const styles = {
  row: {
    display: 'flex',
    alignItems: 'center',
    gap: 10,
    marginBottom: 8,
  },
  team: {
    width: 110,
    fontSize: 12,
    color: 'var(--text-primary)',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  barWrap: {
    flex: 1,
    height: 8,
    background: 'var(--border)',
    borderRadius: 4,
    overflow: 'hidden',
  },
  bar: {
    height: '100%',
    borderRadius: 4,
    transition: 'width var(--duration-slow) ease',
  },
  pct: {
    width: 36,
    fontSize: 12,
    color: 'var(--text-secondary)',
    textAlign: 'right',
  },
}
